module.exports = __webpack_public_path__ + "static/media/ic-history-active.505e99e6.svg";